import React from "react"
import "./Footer.css"

const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <>
      <footer>
        <div className='conatiner text-center top'>
          <div className='myImg'>
            <img src="https://i.postimg.cc/CxBzM8WG/DSC-8114-8x10-removebg-preview-1.png" alt='' />
          </div>
          <p>© {year}. All rights reserved by Suraj-Badwaik.</p>
        </div>
      </footer>
    </>
  )
}

export default Footer
